type PushNotificationPrompt = {
  show: boolean;
};

export const usePushNotificationPrompt = () =>
  useState<PushNotificationPrompt>('pushNotificationPrompt', (): PushNotificationPrompt => {
    return {
      show: false,
    };
  });
